import { get } from './objectHelpers';

type Descriptor = [
    string | Array<string>,
    Function,
    Array<any>
]

type Descriptors = Array<Descriptor> | 'NOT_PROVIDED'
interface Data {
    taxHousehold?: object
}

export const extractPreviousData = (
    currentData: Data,
    previousData: Data,
    desc: Descriptors,
    value: any,
    shouldDefaultPreviousData: boolean | unknown,
    indexMapper: {
        currentValues: object,
        previousValues: object
    }
) => {

    const NOT_PROVIDED: string = 'NOT_PROVIDED';

    let currentValue;
    let previousValue;
    let previouslyDidNotExist = false;


    if (desc === NOT_PROVIDED || shouldDefaultPreviousData) {
        currentValue = value;
        previousValue = NOT_PROVIDED;
    } else {
        if (Array.isArray(desc)) {

            let currentValueResult: any = [];
            let previousValueResult: any = [];

            desc.forEach(descriptor => {
                let currentDataValues: Array<any> = [];
                let prevDataValues: Array<any> = [];

                const [
                    path,
                    refineFunction,
                    defaultParams = []
                ] = descriptor;

                const replace = (str, replacements) => {
                    const indexRegEx = /\[(.*?)\]/;
                    const indexPatternMatches = str.match(indexRegEx);

                    if (indexPatternMatches) {
                        const match = indexPatternMatches[1];
                        const replacement = replacements[match];

                        if(replacement === '-1') {
                            previouslyDidNotExist = true;
                        }

                        if(replacement) {
                            const formattedReplacement = `[${ replacement }]`;
                            return str.replace(indexRegEx, formattedReplacement);
                        } else {
                            return str;
                        }

                    } else {
                        return str;
                    }
                };

                if (Array.isArray(path)) {
                    path.forEach((p: string): void => {
                        if(p === 'DATA') {
                            currentDataValues.push(currentData);
                            prevDataValues.push(previousData);
                        } else if (p === 'DATA.TAX_HOUSEHOLD') {
                            currentDataValues.push(currentData.taxHousehold);
                            prevDataValues.push(previousData.taxHousehold);
                        } else {
                            currentDataValues.push(get(currentData, replace(p, indexMapper.currentValues)));
                            prevDataValues.push(get(previousData, replace(p, indexMapper.previousValues)));
                        }
                    });
                } else {
                    currentDataValues = [ get(currentData, replace(path, indexMapper.currentValues)) ];
                    prevDataValues = [ get(previousData, replace(path, indexMapper.previousValues)) ];
                }

                const applyRefineFunction = (resultAccumulator, values) => {
                    resultAccumulator.push(refineFunction.apply(null, [ ...values, ...defaultParams ]));
                };

                if(refineFunction) {
                    applyRefineFunction(currentValueResult, currentDataValues);
                    applyRefineFunction(previousValueResult, prevDataValues);
                } else {
                    currentValueResult =  currentDataValues;
                    previousValueResult =  prevDataValues;
                }
            });

            const normalizeValue = value => {
                if(value.length === 1) {
                    const [ onlyOneElement ] = value;
                    return onlyOneElement;
                }
                // So far default return is not used. Will be used if extractPreviousData gets multiple descriptors
                return value;
            };

            currentValue = normalizeValue(currentValueResult);
            previousValue = normalizeValue(previousValueResult);
        }
    }

    if(previouslyDidNotExist) {
        return {
            currentValue: value,
            previousValue: NOT_PROVIDED
        };
    }

    return {
        currentValue,
        previousValue
    };
};